import request from '@/utils/request';
import { RParam } from '@/api';
import type { ApiResult, PageResult, RP } from '@/api';
import type { I18n } from './model';
import { getAppId } from '@/utils/lzd-util';

const BASE_URL = '/bsl/system/i18n/manager';

/**
 * 分页查询国际化配置
 */
export async function pageI18ns(params: RP) {
  params.where = params.where ?? [];
  const res = await request.post<ApiResult<PageResult<I18n>>>(
    `${BASE_URL}/query/page`,
    params
  );
  return res.data.code === 0 ? res.data.data : Promise.reject(res.data);
}

/**
 * 添加国际化配置
 */
export async function addI18n(data: I18n) {
  data.appId = getAppId();
  const res = await request.post<ApiResult<unknown>>(
    `${BASE_URL}/insert`,
    data
  );
  return res.data.code === 0 ? res.data : Promise.reject(res.data);
}

/**
 * 修改国际化配置
 */
export async function updateI18n(data: I18n) {
  const res = await request.post<ApiResult<unknown>>(`${BASE_URL}/update`, {
    update: RParam.buildEdit(data, (k: string) => k !== 'seq'),
    where: [RParam.eq('seq', data.seq)]
  });
  return res.data.code === 0 ? res.data : Promise.reject(res.data);
}

/**
 * 删除国际化配置
 */
export async function removeI18n(data: (number | undefined)[]) {
  const res = await request.post<ApiResult<unknown>>(`${BASE_URL}/delete`, {
    where: RParam.buildWhere({ seq: data })
  });
  return res.data.code === 0 ? res.data : Promise.reject(res.data);
}

/** 国际化翻译 */
export function toI18n(text: string) {
  // 先直接返回，后续完善支持
  return text;
}
